import { L } from "../i18n";
// Fictional personas for the "Legal & Compliance" illustrative section.
// These are FICTIONAL website personas, clearly labelled as such. They do NOT
// represent real employees, lawyers, law firms or professional relationships.
const legalTeam__raw = [
  {
    name: "Daniel Whitmore",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Banking & Finance",
    image:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1MjcwN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sophie Bennett",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Financial Services Regulation",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1MjcwN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "James Harrington",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Corporate & Commercial Finance",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1MjcwN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Emily Crawford",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Capital Markets",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1MjcwN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Thomas Wainwright",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Financial Compliance",
    image:
      "https://images.unsplash.com/photo-1685760259914-ee8d2c92d2e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTAxNTI3MDd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Charlotte Morgan",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Financial Regulation",
    image:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTAxNTI3MDd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Richard Beaumont",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "Commercial & Corporate Law",
    image:
      "https://images.pexels.com/photos/4872060/pexels-photo-4872060.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Oliver Kensington",
    role: "Legal & Financial Services Counsel",
    location: "London, United Kingdom",
    focus: "International Banking & Finance",
    image:
      "https://images.pexels.com/photos/5583988/pexels-photo-5583988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

const legalSectionCopy__raw = {
  heading: "Legal & Compliance",
  subtitle:
    "Professional legal and compliance expertise across banking, finance and financial services.",
  disclaimer:
    "Illustrative profiles only. The individuals shown on this page are fictional website personas and do not represent actual employees, lawyers, law firms, legal advisers or professional relationships. This section is provided for design and informational purposes only.",
};

export const legalTeam = L(legalTeam__raw);
export const legalSectionCopy = L(legalSectionCopy__raw);
